import { Box, Typography } from "@mui/material";
import { NoSearchResultsvg } from "@platformx/shared/static-assets";
import { useTranslation } from "react-i18next";

const NoSearchResult = () => {
  const { t } = useTranslation();

  return (
    <Box
      textAlign='center'
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'>
      <img alt={t("no_result_found")} src={NoSearchResultsvg} width={175} height={175} />
      <Typography variant='h3bold'>{t("no_result_found")}</Typography>
      <Typography variant='h5regular'>{t("try_with_different_keyword")}</Typography>
    </Box>
  );
};

export default NoSearchResult;
